//BRAND
export const name = 'STARLEARN AI';
export const company = 'STARLEARN AI';
export const websiteURL = 'https://starlearn-ai.web.app';
export const serverURL = 'https://starlearn.onrender.com';
export const logo = 'https://firebasestorage.googleapis.com/v0/b/starlearn-ai.appspot.com/o/favicon.png?alt=media&token=ac88070f-a86c-42c6-ad1e-7273e723324a';
export const razorpayEnabled = false;
export const paypalEnabled = true;
export const stripeEnabled = false;
export const paystackEnabled = true;

//PRICING :-

//FREE 
export const FreeType = 'Free Plan';
export const FreeCost = 0;
export const FreeTime = '';

//MONTHLY 
export const MonthType = 'Monthly Plan';
export const MonthCost = 9;
export const MonthTime = 'month';

//YEARLY 
export const YearType = 'Yearly Plan';
export const YearCost = 99;
export const YearTime = 'year';

//TESTIMONIAL
export const review = "Generative AI has the potential to revolutionize nearly every industry, including healthcare, finance, and education";
export const from = "Sam Altman";
export const profession = 'CEO at OPENAI';
export const photoURL = 'https://firebasestorage.googleapis.com/v0/b/starlearn-ai.appspot.com/o/Altman.jpg?alt=media&token=c639f9dd-967b-4c1a-82e9-bff1c857f8e3'
//PAYPAL
export const paypalPlanIdOne = "P-6U775200842434038M2IBQPA";
export const paypalPlanIdTwo = "P-7AB345009G498612TM2IBTFI";

//RAZORPAY
export const razorpayKeyId = "rzp_test_uqALjZHyTyuiOm";
export const razorpayPlanIdOne = "plan_NMvvtDfznbRp6V";
export const razorpayPlanIdTwo = "plan_NMRc9HARBQRLWA";

//STRIPE
export const stripePlanIdOne = "price_1OTo7CSDXmLtVnVeaHIHxqCj";
export const stripePlanIdTwo = "price_1OTo7eSDXmLtVnVeBbn82U5B";

//PAYSTACK
export const paystackPlanIdOne = "PLN_xtb5bmdydoq8ft2";
export const paystackPlanIdTwo = "PLN_11ujqidac5pzqwx";
export const amountInZarOne = '153000';
export const amountInZarTwo = '139000';
